import React from 'react';
import * as e from '../elements';

export default {
  name: 'Video Cover w/ Signup Form',
  description: 'Cover with a showcase video and a signup form',
  thumb: 'coming-soon',
  tags: ['Cover', 'Video'],
  jsx: (
    <e.PBlock width="" className="py-5">
      <div className="row align-items-center">
        <div className="col-12 order-2 text-center col-md-6 order-md-1 my-3">
          <e.PVideo />
        </div>
        <div className="col-12 order-1 col-md-6 order-md-2">
          <div className="row">
            <div className="col-12 text-center text-md-left">
              <e.PText key="1" text="Provide us with your contact details and we will get back to you." size="text-md" className="mb-3" />
            </div>
          </div>
          <form>
            <div className="form-group row">
              <label className="col-sm-12 col-form-label">Name</label>
              <div className="col-sm-12">
                <input
                  type="text" className="form-control"
                  value="first name last name"
                />
              </div>
            </div>
            <div className="form-group row">
              <label className="col-sm-12 col-form-label">Email</label>
              <div className="col-sm-12">
                <input
                  type="text" className="form-control"
                  value="email@example2.com"
                />
              </div>
            </div>
            <div className="form-group row">
              <label className="col-sm-12 col-form-label">Message</label>
              <div className="col-sm-12">
                <textarea
                  type="text" className="form-control"
                  value="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
                  rows="3"
                />
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <e.PButton text="submit" size="xl" color="primary" />
              </div>
            </div>
          </form>
        </div>
      </div>
    </e.PBlock>
  ),
};



// WEBPACK FOOTER //
// ./scripts/components/editor/blocks/CoverVideoSignup.jsx